<template>
    <div class="modal-card card">
        <form @submit.prevent="onFormSubmit()">
            <div class="card-header">
                <!-- Title -->
                <h4 class="card-header-title">Renew Certificate</h4>
                <!-- Close -->
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="card-body">
                <p class="mb-3">
        Are you sure you want to renew the following certificate?
    </p>

    <div class="alert alert-warning">
        <i class="fa fa-exclamation-triangle me-2"></i>
        <strong>Warning</strong>
        <p class="mb-0 mt-2">
            Renewing this certificate will start the renewal process from the beginning.
            Please proceed only if you understand this impact.
        </p>
    </div>

    <ul class="list-group list-group-sm mt-3">
        <li class="list-group-item">
            {{ modalData.commonName }}
        </li>
    </ul>
            </div>
            <div class="card-footer text-end">
                <button class="btn btn-primary" :disabled="renewInProgress">
                    <div v-if="renewInProgress" class="spinner-border spinner-border-sm" role="status">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                    <div v-else>
                        Renew
                    </div>
                </button>
            </div>
        </form>
    </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
    data() {
        return {
            error: "",
            renewInProgress: false
        };
    },
    props: {
        modalData: {
            type: [Object, Array, String],
        },
    },
    name: "DeleteCertificates",
    methods: {
        ...mapActions("aut", {
            renewCertificate: "renewCertificate",
        }),
        async onFormSubmit() {
            this.renewInProgress = true;
            let toastOptions = {
                message: "Certificate renewed successfully.",
                type: "success"
            }
            try {
                await this.renewCertificate({commonName: this.modalData.commonName, payload: {}})
            } catch (error) {
                if (error.response.data.error)
                    this.error = error.response.data.error;
                else this.error = error.message;
                toastOptions = {
                    message: this.error || "Something went wrong while renewing certificates. Please contact support.",
                    type: "error"
                }
                return;
            } finally {
                this.renewInProgress = false;
                this.$store.dispatch("addToast", toastOptions);
            }
            this.$store.dispatch("hideModal");
            this.$store.state.aut.renewCertTrigger = !this.$store.state.aut.renewCertTrigger;
        },
    },
};
</script>

<style></style>